import { Vector2d } from "@stage/math";
import { CubicBezierCurve } from "@stage/path";
export var Curves;
(function (_Curves) {
  function fittingCubicBeziers(begin, center, radius, to) {
    var vs = Vector2d.sub(begin, center);
    var ve = Vector2d.sub(to, center);
    //坐标系相反的，则>180度 是顺时针
    var largeArcFlag = Vector2d.det(vs, ve) < 0;
    if (largeArcFlag) {
      var intp = Vector2d.add(Vector2d.multiplyScalar(vs, 0.5), Vector2d.multiplyScalar(ve, 0.5));
      intp = Vector2d.multiplyScalar(Vector2d.normalize(intp), radius);
      intp = Vector2d.add(center, Vector2d.rotate(intp, 180));
      //拆分2个圆弧
      return [_fittingCubicBezier(begin, center, radius, intp), _fittingCubicBezier(intp, center, radius, to)];
    } else {
      //小圆
      return [_fittingCubicBezier(begin, center, radius, to)];
    }
  }
  _Curves.fittingCubicBeziers = fittingCubicBeziers;
  function fittingRoutingCubicBezier(sn, en, round) {
    var radian = Math.acos(Vector2d.dot(sn, en) / (Vector2d.lengthOf(sn) * Vector2d.lengthOf(en)));
    var radius = round / Math.tan(radian / 2);
    var h = 4 / 3 * (1 - Math.cos(radian / 2)) / Math.sin(radian / 2);
    return {
      cv1: Vector2d.multiplyScalar(sn, h * radius),
      cv2: Vector2d.multiplyScalar(en, h * radius)
    };
  }
  _Curves.fittingRoutingCubicBezier = fittingRoutingCubicBezier;
  function _fittingCubicBezier(begin, center, radius, to) {
    //以圆中心做原点
    var vs = Vector2d.sub(begin, center);
    var ve = Vector2d.sub(to, center);

    //圆弧，开始&结束 做个单位向量再衍伸 半径r  正常vs=rs  ve=re
    var rsn = Vector2d.normalize(vs);
    var ren = Vector2d.normalize(ve);
    var rs = Vector2d.multiplyScalar(rsn, radius);
    var re = Vector2d.multiplyScalar(ren, radius);
    //圆弧-弧度计算? 可靠？ 还是应该结合r调整？
    var radian = Math.acos(Vector2d.dot(ren, rsn) / (Vector2d.lengthOf(ren) * Vector2d.lengthOf(ren)));
    var h = 4 / 3 * (1 - Math.cos(radian / 2)) / Math.sin(radian / 2);
    var c1 = Vector2d.add(rs, Vector2d.multiplyScalar(Vector2d.rotate(rsn, 90), h * radius));
    var c2 = Vector2d.add(re, Vector2d.multiplyScalar(Vector2d.rotate(ren, -90), h * radius));

    //取消center为原点恢复坐标系
    return new CubicBezierCurve(Vector2d.add(center, c1), Vector2d.add(center, c2), to);
  }
  _Curves._fittingCubicBezier = _fittingCubicBezier;
})(Curves || (Curves = {}));